<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Core Values</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a routerLink="javascript:void(0);">Core Values</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="core-value ptb--100 ">
  <div class="container">
    <div class="row">
      <div class="col">
        <h4 class="yellow-color fw-bold">Core Values of the Institute</h4>
        <ul class="list-before">
          <li>To impart quality education through traditional and innovative learning practices.</li>
          <li>To develop the institute in to a center of academic excellence.</li>
          <li>To maintain its traditional of high quality of education from a decade and be one of the worlds recognized
            center for imparting “Quality Education”.</li>
          <li>To provide a dynamic and creative academic envirnment,to tap and nature talent for the development of
            professional skills and an all round personality.</li>
          <li>To inculcate good moral values and a sense of nationalism in keeping with the glorious heritage of the
            institute.</li>
          <li>To provide education through discovery and dissemination of knowledge,development of technical and social
            skill and inculcate values that define professional conduct.</li>
          <li>To produce graduates capable of self-determining,life long learning and gain practical eaperience in
            respective fields.</li>
          <li>To provide a holistic concept of education,of Man-making Education.</li>
          <li>To Foster a strong sense of belonging ti the institution,Society and country.</li>
          <li>To produce students who will be acknowledged worldwide for their creativity,knowledege and skills based on
            their inherent ability.</li>
          <li>To provide an environment in which staff and students can achiveve their full potential.</li>
          <li>To provide our youth opporunities to fulfill their needs and aspiration for their socio-economic
            developemnt through the acquisition of various skills.</li>
        </ul>
      </div>
    </div>
  </div>
</section>
